const routeConstant = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index.vue'),
    hidden: true
  },
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/home.vue'),
    hidden: true
  },
  {
    path: '/merchant-device-binding',
    name: 'merchant-device-binding',
    component: () => import('@/views/merchant-device-binding/index.vue'),
    hidden: true
  },
  {
    path: '/login-old',
    name: 'login-old',
    component: () => import('@/views/login-old.vue'),
    hidden: true
  },
  {
    path: '/network-error',
    name: 'network-error',
    component: () => import('@/views/error-page/network-error.vue'),
    hidden: true
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/error-page/404.vue'),
    hidden: true
  }
]

export default routeConstant
